export default "__VITE_PUBLIC_ASSET__bfe64694__"